/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContratAvenantGridDto } from './ContratAvenantGridDto';
import {
    ContratAvenantGridDtoFromJSON,
    ContratAvenantGridDtoFromJSONTyped,
    ContratAvenantGridDtoToJSON,
} from './ContratAvenantGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContratAvenantGridDtoPaginatedResults
 */
export interface ContratAvenantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContratAvenantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContratAvenantGridDto>}
     * @memberof ContratAvenantGridDtoPaginatedResults
     */
    results?: Array<ContratAvenantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContratAvenantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContratAvenantGridDtoPaginatedResults interface.
 */
export function instanceOfContratAvenantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratAvenantGridDtoPaginatedResultsFromJSON(json: any): ContratAvenantGridDtoPaginatedResults {
    return ContratAvenantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContratAvenantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratAvenantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContratAvenantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContratAvenantGridDtoPaginatedResultsToJSON(value?: ContratAvenantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContratAvenantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

